import axios from "axios"
import { post, del, get, put, postWithFormData } from "./api_helper"
import * as url from "./url_helper"

// Create School
export const uploadStudents = data => postWithFormData(url.UPLOAD_STUDENTS, data);
export const loginStudentWithCred = data => post(url.LOGIN_STUDENT, data);
export const getStudentsForMapping = () => get(url.GET_STUDENTS_FOR_MAPPING);

export const createStudent = data => post(url.CREATE_STUDENT, data);
export const updateStudent = data => put(url.UPDATE_STUDENT, data);
export const getAllStudents = () => get(url.FETCH_ALL_STUDENTS);
export const getAllStudentsForTata = () => get(url.FETCH_ALL_STUDENTS_FOR_TATA);
export const getSingleStudent = id => get(url.FETCH_SINGLE_STUDENT + id);
export const deleteStudent = id => del(url.DELETE_STUDENT + id);
export const createMultipleStudnet = data => post(url.CREATE_STUDENT_FROM_FILE, data);
export const fetchAllCourseOfStudent = id => get(url.FETCH_ALL_COURSE_OF_STUDENT + id);


